import i18n from "../i18n";

export const getApiErrorMessage = (error, fallback = "Request failed") => {
  const detail = error?.response?.data?.detail;

  if (!detail) return fallback;
  // The backend raises i18n KEYS as its detail (e.g.
  // "error.supplier_invoices.project_not_found"), never prose. Resolve them
  // here, at the one choke point every caller already goes through, so a raw
  // dot-key can never reach a toast. A key with no translation falls back to
  // the caller's message rather than showing the key itself.
  if (typeof detail === "string") {
    return detail.startsWith("error.")
      ? i18n.t(detail, { defaultValue: fallback })
      : detail;
  }

  // FastAPI validation errors
  if (Array.isArray(detail)) {
    return detail.map(d => d?.msg || "Validation error").join(" | ");
  }

  // Structured detail: `{"error_code": "error.x.y", ...}`. Several routes have
  // used this shape for a while (fx.py, expenses.py, invoices.py,
  // supplier_invoices.py) to carry an i18n key ALONGSIDE extra context, such as
  // the addresses a bulk write refused. Until now this branch stringified the
  // whole object, so every one of those sites showed the user raw JSON —
  // `{"error_code":"error.fx.rate_unavailable",...}` in a toast. Resolve the
  // key exactly as the string branch does; the surrounding context is for the
  // caller to use if it wants, not for the generic message.
  if (typeof detail === "object") {
    const code = detail.error_code;
    if (typeof code === "string" && code.startsWith("error.")) {
      return i18n.t(code, { defaultValue: fallback });
    }
    return fallback;
  }

  return String(detail);
};
